// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// import fullpage from "fullpage.js";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { get_viewportState } from "../../../init/init_viewportState";

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_fullpage() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const api = this.api;

  // Manual query + store back-to-top btn. ref.
  // const btn_backToTop = document.querySelector("[g-ref='SectionScroller:btn_backToTop']");
  // this.ref.btn_backToTop = btn_backToTop;

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  new fullpage(this.element, {
    sectionSelector: ".section:not([data-hidden-full=true])",
    scrollOverflowResetKey: "MXJkMlZzWTI5dFpTMWhiR3hwWVc1alpTNXZjbWM9NktfYlFNYzJOeWIyeHNUM1psY21ac2IzZFNaWE5sZEE9PWpFVw==",
    scrollOverflowReset: true,
    scrollOverflow: true,
    onLeave: (origin, dest, dir) => {
      //////////////////////////////// Setup /////////////////////////////////
      ////////////////////////////////////////////////////////////////////////

      const anchor_origin = origin.anchor;
      const anchor_target = dest.anchor;
      const chapter_target = dest.item.getAttribute("data-chapter");

      /////////////// Auto-scroll block out of gateway section ///////////////
      ////////////////////////////////////////////////////////////////////////

      const activeSection = fullpage_api.getActiveSection();
      // if (activeSection.anchor === "gateway" && dir === "down" && !this.state.gatewayOpen) return false;
      if (activeSection.anchor === "intro" && dir === "down" && !this.state.gatewayOpen) return false;

      ////////////////////// Active section state updt. //////////////////////
      ////////////////////////////////////////////////////////////////////////

      // Find first wrprs_content in target section
      const el_wrpr = dest.item.querySelector('[g-ref="wrprs_content"]');
      const id_wrpr = el_wrpr ? el_wrpr.dataset.id : null;
      this.setState({ activeSection: id_wrpr });

      /////////////////// Custom route behav.: gateway -> ////////////////////
      ////////////////////////////////////////////////////////////////////////

      // Hide gateway while leaving gateway section downwards
      // if (anchor_origin === "gateway" && dir === "down") {
      //   api.showHide_gateway("hide");
      //   setTimeout(() => api.showHide_gateway("show"), 700);
      // }

      ///////////////////// Custom route behav.: -> hero /////////////////////
      ////////////////////////////////////////////////////////////////////////

      // Hide all sections while entering hero section
      // if (anchor_target === "hero") {
      //   sections.filter((s) => s.dataset.anchor !== "hero").forEach((s) => (s.dataset.hidden = "true"));
      //   setTimeout(() => sections.forEach((s) => (s.dataset.hidden = "false")), 700);
      // }

      //////////////////////// Back-to-top btn. updt. ////////////////////////
      ////////////////////////////////////////////////////////////////////////

      this.ref.btn_backToTop.dataset.rotate = anchor_target !== "intro" ? "true" : "false";
      // btn_backToTop.href = `#${anchor_target !== "intro" ? "intro" : "bewerben"}`;

      ////////////////////////// Active nav. updt. ///////////////////////////
      ////////////////////////////////////////////////////////////////////////

      this.setState({ onFullpageLeave: true }); // temp. disable nav. reveal by scroll triggers

      // Toggle nav. corresp. to origin el. (wrpr.) chapter (unless on mobile)
      if (!get_viewportState().is_mob) {
        const { wrpr_btnGroups } = this.ref;
        if (wrpr_btnGroups) api.toggle_nav(el_wrpr, { setFirstLinkActive: true });
      }

      setTimeout(() => this.setState({ onFullpageLeave: false }), 1500);
    },
    // afterLoad: (origin, dest) => {
    //   console.log("after load", dest);

    //   this.setState({ afterFullpageLoad: true }); // temp. disable nav. reveal by scroll triggers

    //   // Toggle nav. corresp. to origin el. (wrpr.) chapter
    //   const { wrpr_btnGroups, nav_intro, nav_bewerben, nav_allgemein } = this.ref;
    //   const el_wrpr = dest.item.querySelector('[g-ref="wrprs_content"]');
    //   if (wrpr_btnGroups) toggleNav(el_wrpr, wrpr_btnGroups, nav_intro, nav_bewerben, nav_allgemein);

    //   setTimeout(() => this.setState({ afterFullpageLoad: false }), 500);
    // },
    // afterRender: () => {
    //   console.log("after render");
    // },
  });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.modules.fullpage = {
    instance: fullpage,

    // Scroll to element within section
    scrollToElement: (elementSelector, sectionAnchor = null, options = {}) => {
      const defaults = { behavior: "smooth", block: "start", inline: "nearest", offset: 0 };
      const opts = { ...defaults, ...options };
      const targetElement = document.querySelector(elementSelector);
      if (!targetElement) {
        console.warn(`Element not found: ${elementSelector}`);
        return false;
      }

      // Find which section contains the target element
      const section = targetElement.closest(".section");
      if (!section) {
        console.warn("Target element is not within a fullpage section");
        return false;
      }

      const anchor = sectionAnchor || section.dataset.anchor;

      // Navigate to the section first
      if (fullpage_api.getActiveSection().anchor !== anchor) fullpage_api.moveTo(anchor);

      // Wait for section transition, then scroll to element
      setTimeout(
        () => {
          const fpOverflow = section.querySelector(".fp-overflow");
          if (fpOverflow) {
            // Calculate scroll position
            const elementRect = targetElement.getBoundingClientRect();
            const containerRect = fpOverflow.getBoundingClientRect();
            const scrollTop = fpOverflow.scrollTop + elementRect.top - containerRect.top - opts.offset;

            // Smooth scroll to position
            fpOverflow.scrollTo({
              top: scrollTop,
              behavior: opts.behavior,
            });
          } else {
            // Fallback: use browser's default scrollIntoView
            targetElement.scrollIntoView({
              behavior: opts.behavior,
              block: opts.block,
              inline: opts.inline,
            });
          }
        },
        fullpage_api.getActiveSection().anchor !== anchor ? 700 : 0,
      );

      return true;
    },

    // Scroll within current section only
    scrollToElementInCurrentSection: (elementSelector, options = {}) => {
      const currentSection = fullpage_api.getActiveSection();
      const targetElement = currentSection.item.querySelector(elementSelector);

      if (!targetElement) {
        console.warn(`Element not found in current section: ${elementSelector}`);
        return false;
      }

      const fpOverflow = currentSection.item.querySelector(".fp-overflow");
      if (fpOverflow) {
        const defaults = { behavior: "smooth", offset: 0 };
        const opts = { ...defaults, ...options };
        const elementRect = targetElement.getBoundingClientRect();
        const containerRect = fpOverflow.getBoundingClientRect();
        const scrollTop = fpOverflow.scrollTop + elementRect.top - containerRect.top - opts.offset;
        fpOverflow.scrollTo({ top: scrollTop, behavior: opts.behavior });
      }

      return true;
    },
  };
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
